import { gql, ApolloClient } from '@apollo/client'
import { GetServerSidePropsContext } from 'next'
import { getApolloClient } from '@libs/getApolloClient'
import {
  RecommendedArticles,
  RecommendedArticlesVariables,
} from '@apollo-types/RecommendedArticles'

const RECOMMENDED_ARTICLES = gql`
  query RecommendedArticles($seedId: String!, $limit: Int) {
    recommendedArticles(seedId: $seedId, limit: $limit) {
      totalCount
      articles {
        id
        postID
        title
        plainTextContent
        metaTitle
        ogTitle
        url
        publishedAt
        categories {
          name
        }
        coverImage {
          croppedUrl
        }
        publisher {
          photoUrl
          name
          mid
        }
      }
    }
  }
`

type GetRecommendedArticlesParams = {
  seedId: string
  limit: number
  client: ApolloClient<unknown>
}

async function getRecommendedArticles(params: GetRecommendedArticlesParams) {
  const { seedId, limit, client } = params
  try {
    const response = await client.query<RecommendedArticles, RecommendedArticlesVariables>({
      query: RECOMMENDED_ARTICLES,
      variables: {
        seedId: seedId.toString(),
        limit,
      },
    })
    const articles = response?.data?.recommendedArticles?.articles ?? []
    return articles
  } catch (error) {
    return { ...error }
  }
}

export default getRecommendedArticles
